import { Dispatch } from 'redux';

export const promisifyDispatch = (dispatch: Dispatch, actionCreator: any) => {
  return (...args: unknown[]) => {
    return new Promise((resolve, reject) => {
      try {
        // dispatch returns a reference to the dispatch function from the Redux store
        resolve(dispatch(actionCreator(...args)));
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          reject(error);
        }
      }
    });
  };
};
